import React, { useState, useEffect } from 'react';
import GoogleMapReact from 'google-map-react';
import ReactSVG from 'react-svg';
import map_marker from 'map_marker.svg';
import ErrorBoundary from './ErrorBoundary';
import CustomAutocomplete from './CustomAutocomplete';

function AutoComplete({
  prefilled_address,
  errors,
  placeholder,
  same_as_business,
}) {
  const [address, setAddress] = useState({});

  useEffect(() => {
    if (same_as_business) {
      const autoInput = document.querySelector(
        '.autocomplete-input-container > input'
      );
      // Set React component and hidden input value to null
      setAddress({ name: prefilled_address });
      document.querySelector('#event_address').value = prefilled_address;
      autoInput.setAttribute('disabled', !autoInput.disabled);
      document
        .querySelector('.autocomplete-input-container')
        .classList.toggle('disabled');
    }
  }, [prefilled_address, same_as_business]);

  useEffect(() => {
    if (prefilled_address) {
      setAddress({ name: prefilled_address });
    }
    const fetchCoords = async () => {
      const service = new window.google.maps.places.PlacesService(
        new window.google.maps.Map(document.querySelector('#map'))
      );
      service.findPlaceFromQuery(
        {
          fields: ['formatted_address', 'geometry.location'],
          query: prefilled_address,
        },
        results => {
          setAddress(results[0]);
        }
      );
    };
    fetchCoords();
  }, [prefilled_address]);

  return (
    <div
      className={`autocomplete-input-container ${
        errors.address[0] ? 'error-field' : ''
      }`}
    >
      <CustomAutocomplete
        apiKey="AIzaSyATvnQePj9OTTCZJ6VkugYM8dRGFPJ5HmQ"
        onPlaceSelected={place => {
          setAddress(place);
          const inputAddress = place.formatted_address
            ? place.formatted_address
            : place.name;
          if ($('input#listing_address').length) {
            $('input#listing_address').val(inputAddress);
          } else if ($('input#event_address').length) {
            $('input#event_address').val(inputAddress);
          }
        }}
        defaultValue={address.formatted_address || address.name}
        types={['address']}
        placeholder={placeholder}
        componentRestrictions={{ country: 'us' }}
        aria-label="Address Input"
      />
      {address.geometry && (
        <section className="listing-map-container">
          {/* <div className="map-cover" /> */}
          <GoogleMapReact
            bootstrapURLKeys={{
              // @TODO: Add this to an environment variable or something
              key: 'AIzaSyATvnQePj9OTTCZJ6VkugYM8dRGFPJ5HmQ',
            }}
            center={{
              lat: address.geometry.location.lat(),
              lng: address.geometry.location.lng(),
            }}
            defaultZoom={12}
            gestureHandling={false}
            zoomControl={false}
          >
            <ReactSVG
              src={map_marker}
              className="listing-map-marker"
              lat={address.geometry.location.lat()}
              lng={address.geometry.location.lng()}
            />
          </GoogleMapReact>
        </section>
      )}
      {/* !!! IMPORTANT !!!  */}
      <div id="map" />{' '}
      {/* This is necessary for the prefilled map to show up */}
      {/* !!! IMPORTANT !!!  */}
    </div>
  );
}

export default function AutoCompleteWrapper({ ...props }) {
  return (
    <ErrorBoundary>
      <AutoComplete {...props} />
    </ErrorBoundary>
  );
}
